import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { showBuildBundlesModal } from '../../actions/';
import { BuildBundlesModalController } from '../buildBundlesModal'

class BundleSegment extends Component {
    render() {
        const {inScene, showBuildBundlesModal} = this.props;

        return [
            <div key='buildbundlediv'>
                <Button key='buildbundlebtn' block type='button' disabled={!inScene} onClick={() => showBuildBundlesModal()}><i className="fas fa-archive"></i>&nbsp; Build Bundles</Button>
            </div>,
            <BuildBundlesModalController key='buildbundlesmodal'/>
        ];
    }
}

const mapStateToProps = state => {
    return {
        scene: state.scene.current
    };
};

const mapDispatchToProps = {
    showBuildBundlesModal
};

BundleSegment.propTypes = {
    inScene:                 PropTypes.bool.isRequired,
    scene:                   PropTypes.string,
    showBuildBundlesModal:   PropTypes.func.isRequired
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BundleSegment);



// WEBPACK FOOTER //
// ./src/components/actionBar/BundleSegment.js